__turbopack_context__.v({
  "cta": "Card-module-scss-module__GK18OW__cta",
  "dirNext": "Card-module-scss-module__GK18OW__dirNext",
  "fade-in": "Card-module-scss-module__GK18OW__fade-in",
  "inner": "Card-module-scss-module__GK18OW__inner",
  "isActive": "Card-module-scss-module__GK18OW__isActive",
  "isPrev": "Card-module-scss-module__GK18OW__isPrev",
  "root": "Card-module-scss-module__GK18OW__root",
  "set-active": "Card-module-scss-module__GK18OW__set-active",
  "swipe-next": "Card-module-scss-module__GK18OW__swipe-next",
  "swipe-prev": "Card-module-scss-module__GK18OW__swipe-prev",
});
